import React from 'react';

export const AdminPanelVendedoresTab = ({
  vendedores,
  setShowAddVendedor,
  copyLink,
  copiedLink,
  siteUrl,
  handleToggleAtivo,
}) => {
  return (
    <div data-testid="admin-panel-vendedores-tab">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900" data-testid="admin-panel-vendedores-title">Gerenciar Vendedores</h2>
        <button
          onClick={() => setShowAddVendedor(true)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition flex items-center gap-2"
          data-testid="admin-panel-add-vendedor-button"
        >
          + Adicionar Vendedor
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="admin-panel-vendedores-list">
        {vendedores.map((vendedor) => (
          <div key={vendedor.id} className="bg-white rounded-2xl shadow-sm overflow-hidden" data-testid={`admin-panel-vendedor-card-${vendedor.id}`}>
            <div className="bg-gradient-to-r from-blue-500 via-purple-500 to-purple-600 p-6 text-white">
              <h3 className="text-2xl font-bold">{vendedor.nome}</h3>
              <p className="text-white/80">@{vendedor.codigo}</p>
            </div>

            <div className="grid grid-cols-3 border-b">
              <div className="p-4 text-center border-r">
                <p className="text-2xl font-bold text-blue-600">{vendedor.leads_carros || 0}</p>
                <p className="text-sm text-gray-500 flex items-center justify-center gap-1"><span className="text-red-500">🚗</span> Carros</p>
              </div>
              <div className="p-4 text-center border-r">
                <p className="text-2xl font-bold text-green-600">{vendedor.leads_casas || 0}</p>
                <p className="text-sm text-gray-500 flex items-center justify-center gap-1"><span className="text-green-500">🏠</span> Casas</p>
              </div>
              <div className="p-4 text-center">
                <p className="text-2xl font-bold text-gray-900">{vendedor.leads_count || 0}</p>
                <p className="text-sm text-gray-500">Total</p>
              </div>
            </div>

            <div className="p-4">
              <p className="text-xs text-gray-500 font-medium mb-3">LINKS PARA ANÚNCIOS (FACEBOOK, INSTAGRAM, TIKTOK)</p>

              <div className="space-y-3">
                <div className="flex items-center justify-between bg-gray-50 rounded-lg p-3">
                  <div className="flex items-center gap-2">
                    <span className="text-red-500">🚗</span>
                    <span className="font-medium text-gray-700">Questionário Carros</span>
                  </div>
                  <button
                    onClick={() => copyLink('carros', vendedor.codigo)}
                    className={`px-4 py-1.5 rounded-full text-sm font-medium transition ${
                      copiedLink === `carros-${vendedor.codigo}` ? 'bg-green-500 text-white' : 'bg-blue-500 text-white hover:bg-blue-600'
                    }`}
                    data-testid={`admin-panel-copy-link-carros-${vendedor.id}`}
                  >
                    {copiedLink === `carros-${vendedor.codigo}` ? '✓ Copiado' : 'Copiar'}
                  </button>
                </div>
                <div className="bg-blue-50 rounded-lg px-3 py-2 text-sm text-blue-700 font-mono break-all" data-testid={`admin-panel-carros-link-preview-${vendedor.id}`}>
                  {siteUrl}/rh/{vendedor.codigo}/carros
                </div>

                <div className="flex items-center justify-between bg-gray-50 rounded-lg p-3">
                  <div className="flex items-center gap-2">
                    <span className="text-green-500">🏠</span>
                    <span className="font-medium text-gray-700">Questionário Casas</span>
                  </div>
                  <button
                    onClick={() => copyLink('casas', vendedor.codigo)}
                    className={`px-4 py-1.5 rounded-full text-sm font-medium transition ${
                      copiedLink === `casas-${vendedor.codigo}` ? 'bg-green-500 text-white' : 'bg-green-500 text-white hover:bg-green-600'
                    }`}
                    data-testid={`admin-panel-copy-link-casas-${vendedor.id}`}
                  >
                    {copiedLink === `casas-${vendedor.codigo}` ? '✓ Copiado' : 'Copiar'}
                  </button>
                </div>
                <div className="bg-green-50 rounded-lg px-3 py-2 text-sm text-green-700 font-mono break-all" data-testid={`admin-panel-casas-link-preview-${vendedor.id}`}>
                  {siteUrl}/rh/{vendedor.codigo}/casas
                </div>
              </div>

              <div className="mt-4 flex items-center gap-4 text-sm text-gray-600">
                {vendedor.email && <span className="flex items-center gap-1"><span>📧</span> {vendedor.email}</span>}
                {vendedor.telefone && <span className="flex items-center gap-1"><span>📱</span> {vendedor.telefone}</span>}
              </div>

              <button
                onClick={() => handleToggleAtivo(vendedor)}
                className={`mt-4 text-sm font-medium ${
                  vendedor.ativo !== false ? 'text-red-500 hover:text-red-600' : 'text-green-500 hover:text-green-600'
                }`}
                data-testid={`admin-panel-toggle-vendedor-${vendedor.id}`}
              >
                {vendedor.ativo !== false ? 'Desativar vendedor' : 'Ativar vendedor'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
